module.exports = __webpack_public_path__ + "static/img/image85.b3fef1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c35/image85.png
// module id = v7N1
// module chunks = 0